import { ck, URLS } from "fire-wind-water";
import SETTURL from "../assets/conf/setting.json";
import { resetURL } from "../../stempcore/src/sbase";

ck.json = true;

let tenantId,
  webinarId,
  preview,
  customFormId,
  linkId,
  urlForm,
  configId,
  instanceId,
  weChatId,
  markCode,
  markType,
  tc,
  isSetting,
  sourceKey,
  returnUrl;
export function init() {
  tenantId = URLS.getURL("tenantId") || URLS.getHash("tenantId");
  webinarId = URLS.getURL("webinarId") || URLS.getHash("webinarId");
  preview = parseInt(URLS.getURL("preview") || URLS.getHash("preview"));
  customFormId = URLS.getURL("customFormId") || URLS.getHash("customFormId");
  linkId = URLS.getURL("linkId") || URLS.getHash("linkId") || "";
  urlForm = URLS.getURL("urlForm") || URLS.getHash("urlForm"); //页面来源
  configId = URLS.getURL("configId") || URLS.getHash("configId");
  instanceId = URLS.getURL("instanceId") || URLS.getHash("instanceId");
  weChatId = parseInt(URLS.getURL("weChatId") || URLS.getHash("weChatId"));
  markCode = URLS.getURL("markCode") || URLS.getHash("markCode");
  markType = URLS.getURL("markType") || URLS.getHash("markType");
  tc = URLS.getURL("tc") || URLS.getHash("tc");
  isSetting = URLS.getURL("isSetting") || URLS.getHash("isSetting");
  sourceKey = URLS.getURL("sourceKey") || URLS.getHash("sourceKey");
  returnUrl = URLS.getURL("returnUrl") || URLS.getHash("returnUrl");
  resetURL(SETTURL);
  if (returnUrl) {
    returnUrl = decodeURIComponent(returnUrl);
    try {
      returnUrl = window.atob(returnUrl);
    } catch (e) {
      console.log(e);
    }
  }
}
let isIframe = function init() {
  return window.top === window.self;
};
init();
export {
  tenantId,
  webinarId,
  preview,
  customFormId,
  linkId,
  returnUrl,
  urlForm,
  configId,
  instanceId,
  weChatId,
  markCode,
  markType,
  tc,
  isSetting,
  sourceKey,
  isIframe,
};
